import { useDispatch, useSelector } from "react-redux";
import { downloadQuarterlySecurityExcel } from "../thunks/downloadReportExcel";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useQuarterlySecurityExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.securityCommission.quarterlylSecurity.downloadReportFetchState);
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadQuarterlySecurityExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
